import React from "react";
import { createRoot } from 'react-dom/client';
import ErrorBox from "../../common/ErrorBox";
import TableComponent from "./TableComponent";
import { useState, useEffect } from "react";
import { ConfigProvider, Modal, App } from 'antd';
import { EditableContextProvider } from "../../common/EditableContextProvider";
import FormComponent from "./FormComponent";
import { customTheme } from "../../common/customTheme";
import { useTramites} from "./useTramites";

export default function Main() {
    const context = useTramites();

    useEffect(() => {
        Promise.all([context.areas.fillAreas(), context.items.fillItems()]);
    }, []);

    return (
        <div>
            <EditableContextProvider data={{
                ...context
            }}
            >
                <div className='my-1 py-1'>
                    <button className="btn btn-sm border agregarBgColor"
                        onClick={() => { context.items.newItem(); }}
                    >
                        <i className="fa-solid fa-plus me-1"></i>
                        Agregar
                    </button>
                </div>
                <TableComponent />

                <Modal title="Formulario"
                    width={900}
                    open={context.formParams.formVisibility}
                    onCancel={context.formParams.hideForm}
                    destroyOnClose={true}
                    footer={null}
                >

                    <FormComponent />
                </Modal>
            </EditableContextProvider>
        </div>
    );
}

let main = document.getElementById('tramites-main');
if (main) {
    const root = createRoot(main);
    root.render(
        <React.StrictMode>
            <ErrorBox>
                <ConfigProvider theme={customTheme}>
                    <App>
                        <Main />
                    </App>
                </ConfigProvider>
            </ErrorBox>
        </React.StrictMode>
    );
}
